function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.2584 14.8419L10 14.686L9.74163 14.8419L4.57613 17.9596L5.94693 12.0836L6.01549 11.7897L5.78739 11.5921L1.22308 7.63803L7.23227 7.12821L7.5327 7.10272L7.65036 6.82511L10 1.2813L12.3496 6.82511L12.4673 7.10272L12.7677 7.12821L18.7769 7.63803L14.2126 11.5921L13.9845 11.7897L14.0531 12.0836L15.4239 17.9596L10.2584 14.8419Z"
});

var SvgStarIconOutline = function SvgStarIconOutline(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/star-icon-outline.bb1605ca.svg";
export { SvgStarIconOutline as ReactComponent };